import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Globe from 'react-globe.gl';
import './Home.css';
import Testimonials from '../../components/Testimonials';
import EventBanner from '../../components/EventBanner';
import useScrollAnimation from '../../Hooks/useScrollAnimation';
import { useDispatch } from 'react-redux';
import { fetchCountryListApi } from '../../apis/api/UtilsApi';

const Dashboard = () => {
  const globeEl = useRef();
  useScrollAnimation();
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchCountryListApi());
  }, [])

  useEffect(() => {
    // Configure globe
    if (globeEl.current) {
      try {
        globeEl.current.controls().autoRotate = true;
        globeEl.current.controls().autoRotateSpeed = 0.5;
        globeEl.current.controls().enableZoom = false;
        globeEl.current.pointOfView({ altitude: 2.5 });
      } catch (error) {
        console.warn('Globe initialization error:', error);
      }
    }

    // Cleanup function
    return () => {
      if (globeEl.current) {
        try {
          // Dispose of the globe renderer
          if (globeEl.current.renderer) {
            globeEl.current.renderer().dispose();
          }
        } catch (error) {
          console.warn('Globe cleanup error:', error);
        }
      }
    };
  }, []);

  return (
    <div className="dashboard-futuristic">
      {/* Hero Section with Globe */}
      <section className="about-hero">
        {/* Tagline Banner */}
        <div className="hero-tagline-banner">
          <span className="hero-tagline-text">Stronger Partnerships. Smarter Logistics.</span>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Building Global Logistics Partnerships</h1>
            <p className="hero-subtitle">
              Connecting independent freight forwarders and logistics companies to strengthen global supply chains and unlock new opportunities worldwide.
            </p>
            <p className="hero-description">
              Elite Freight Forwarders Network (EFFN) is a professional network of independent freight forwarders and logistics providers spanning multiple continents. Our platform empowers members to maintain their identity and operational independence while accessing a coordinated network of trusted partners to grow and compete globally.
            </p>
            <Link to="/join-us" className="btn-hero-primary">
              Explore Membership
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
          <div className="hero-visual">
            <div className="globe-3d-container">
              <Globe
                key="home-globe"
                ref={globeEl}
                globeImageUrl="//unpkg.com/three-globe/example/img/earth-blue-marble.jpg"
                bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
                backgroundImageUrl="//unpkg.com/three-globe/example/img/night-sky.png"
                atmosphereColor="rgba(135, 206, 250, 0.3)"
                atmosphereAltitude={0.15}
                width={500}
                height={500}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <div className="scroll-reveal">
        <Testimonials />
      </div> 

      {/* Event Banner */}
      <div className="scroll-reveal">
        <EventBanner />
      </div>
    </div>
  );
};

export default Dashboard;
